import { useTranslation } from "react-i18next";

import { ITranslation } from "../types";

export const useDataObjectTranslation = (data: ITranslation | null) => {
    const {
        i18n: { language, languages },
    } = useTranslation();

    if (!data) {
        return "";
    }

    const preferedTranslation = data[language];

    if (preferedTranslation) {
        return preferedTranslation;
    }

    return languages.find((lang) => data[lang]) || Object.values(data)[0];
};
